import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import TextField from "../../../Address/Textfield"
import AddressComponent from "../../../Address/Address"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {BusinessAddressVerificationDocumentFormValues} from "./types"
import {addressValidation, nameValidation} from "./validationSchemas"

interface BusinessAddressVerificationDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: BusinessAddressVerificationDocumentFormValues
	onSubmit: (values: BusinessAddressVerificationDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	businessName: nameValidation,
	address: addressValidation,
})

export const BusinessAddressVerificationDocumentForm = ({
	documentType,
	initialValues,
	onSubmit,
	formId,
}: BusinessAddressVerificationDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit, setFieldValue}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Business Name</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter business name"
						name="businessName"
						value={values.businessName}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">Address</div>
					<AddressComponent
						closed={false}
						namePrefix="address."
						street={values.address.street}
						street2={values.address.street2}
						city={values.address.city}
						state={values.address.state ?? ""}
						postalCode={values.address.postalCode}
						country={values.address.country}
						isUsOnlyAddress={false}
						handleChange={handleChange}
						handleBlur={handleBlur}
						setFieldValue={setFieldValue}
					/>
				</form>
			)}
		</Formik>
	)
}
